import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Type Provider",
description: "Explains how Freon uses the type provider (typer) definition to determine and enforce typing rules in your language metamodel.",
tags: [ "Freon", "typer", "type provider", "typing rules", "language definition", "metamodel", "conformance", "inference"] ,
modifiedTime: "2025-11-07T18:52:21.430Z",
publishedTime: "2025-11-07T17:20:18.624Z"
    }
  };
};